<div
  [ngClass]="{
    'base-app-layout': true,
    'content-container': true,
  }"
>
  <div class="base-app-header">
    <app-header />
  </div>

  <div class="base-app-banner">
    <app-banner />
  </div>

  <div class="base-app-main">
    <router-outlet></router-outlet>
  </div>

  <div class="base-app-footer">
    <app-footer />
  </div>
</div>
